<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Rodadas de Negócio</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn depressed small fab color="primary lighten-4" class="ml-2" @click="tooglePesquisa">
            <v-icon>search</v-icon>
          </v-btn>
          <v-btn depressed color="primary lighten-4" @click="$router.push('rodadas/adicionar')"
            class="hidden-xs-only ml-2" v-if="$auth.user.tipo == 'master'">Adicionar</v-btn>
          <v-btn fab small color="primary lighten-4" @click="$router.push('rodadas/adicionar')"
            class="hidden-sm-and-up ml-2" v-if="$auth.user.tipo == 'master'">
            <v-icon>add</v-icon>
          </v-btn>
        </v-app-bar>

        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa" class="pa-2">
            <v-col>
              <v-text-field ref="pesquisa" label="Pesquisa" v-model="pesquisa" prepend-inner-icon="search" solo
                background-color="grey lighten-2" clearable single-line hide-details placeholder="Pesquisa"
                @click:clear="tooglePesquisa"></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-expand-transition>
          <v-col class="red lighten-5" v-show="rodada.id"
            style="display: flex; gap: 10px; align-items: center; justify-content: space-between">
            <v-label style="text-align: right; color: red; margin-right: 10px;">Pedidos e relatórios serão carregados
              baseados na rodada
              selecionada</v-label>
            <v-chip v-if="rodada && !rodada.permitir_pedidos" small color="red" text-color="white"
              style="min-width: 112px">Apenas consulta</v-chip>
            <!-- <v-checkbox
              v-if="
                rodada && rodada.permitir_pedidos && (offLine || showOffline)
              "
              v-model="offLine"
              label="Off-Line"
              class="pa-0 ma-0"
              hide-details
              @change="setOffLineState"
            /> -->
          </v-col>
        </v-expand-transition>

        <v-divider />

        <v-data-table :search="pesquisa" :headers="headers" :items="rodadas" hide-default-footer :loading="loading"
          no-data-text="Sem registros" no-results-text="Sem registros" loading-text="Carregando dados...">
          <template v-slot:item.ativa="{ item }">
            <v-btn icon @click="selecionarRodada(item)">
              <v-icon>{{
                rodada.id === item.id
                  ? "mdi-checkbox-marked"
                  : "mdi-checkbox-blank-outline"
              }}</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.local="{ item }">
            <div class="pt-1">{{ item.local }}</div>
            <div class="caption" style="color: grey; line-height: 1.3">
              {{ item.cidade_nome }}
            </div>
            <div class="caption pb-1" style="color: grey; line-height: 1.3">
              {{ item.estado_nome }}
            </div>
          </template>
          <template v-slot:item.data_inicio="{ item }">
            <div class="pt-1">{{ item.data_inicio | dataBR }}</div>
          </template>
          <template v-slot:item.data_fim="{ item }">
            <div class="pt-1">{{ item.data_fim | dataBR }}</div>
            <div class="caption pb-1" style="color: grey; line-height: 1.3">
              Limite {{ item.data_limite | dataBR }}
            </div>
          </template>

          <template v-if="$auth.user.tipo == 'fornecedor'" v-slot:item.opcoes="{ item }">
            <v-btn icon @click="abrirDialogoDetalhes(item)">
              <v-icon v-if="$auth.user.tipo == 'fornecedor'">mdi-information</v-icon>
            </v-btn>
          </template>

          <template v-else v-slot:item.opcoes="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon v-if="$auth.user.tipo == 'fornecedor'">more_vert</v-icon>
                  <v-icon v-else>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list v-if="$auth.user.tipo != 'fornecedor'" dense>
                <v-list-item @click="$router.push('rodadas/' + item.id + '/editar')" v-if="
                  ($auth.user.tipo == 'master' ||
                    $auth.user.tipo == 'administrador') &&
                  podeEditar(item.data_fim)
                ">
                  <v-list-item-title>
                    <v-icon class="pr-4">edit</v-icon>Editar
                  </v-list-item-title>
                </v-list-item>

                <!-- <v-list-item
                  @click="$router.push('rodadas/' + item.id + '/editar')"
                  v-else
                >
                  <v-list-item-title>
                    <v-icon class="pr-4">list_alt</v-icon>Detalhes
                  </v-list-item-title>
                </v-list-item> -->

                <v-list-item v-if="$auth.user.tipo == 'administrador'"
                  @click="$router.push('rodadas/' + item.id + '/stands')">
                  <v-list-item-title>
                    <v-icon class="pr-4">store</v-icon>Stands
                  </v-list-item-title>
                </v-list-item>

                <v-list-item v-if="
                  $auth.user.tipo == 'administrador' ||
                  $auth.user.tipo == 'representante'
                " @click="$router.push('rodadas/' + item.id + '/clientes')">
                  <v-list-item-title>
                    <v-icon class="pr-4">group</v-icon>Clientes
                  </v-list-item-title>
                </v-list-item>

                <v-list-item v-if="
                  $auth.user.tipo == 'administrador' ||
                  $auth.user.tipo == 'representante'
                " @click="$router.push('rodadas/' + item.id + '/fornecedores')">
                  <v-list-item-title>
                    <v-icon class="pr-4">people_outline</v-icon>Fornecedores
                  </v-list-item-title>
                </v-list-item>

                <v-list-item v-if="
                  $auth.user.tipo == 'administrador' ||
                  $auth.user.tipo == 'representante'
                " @click="
                  $router.push('rodadas/' + item.id + '/representantes')
                  ">
                  <v-list-item-title>
                    <v-icon class="pr-4">work</v-icon>Representantes
                  </v-list-item-title>
                </v-list-item>

                <v-list-item @click="abrirDialogoDetalhes(item)" v-if="$auth.user.tipo != 'administrador'">
                  <v-list-item-title>
                    <v-icon class="pr-4">mdi-text-box-check-outline</v-icon>Detalhes
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>

      <as-dialogo ref="dialogoDetalhes" title="Detalhes da Rodada" max-width="1000px" hideDivider>
        <v-form ref="form">
          <v-row dense>
            <v-col sm="3">
              <v-text-field label="Nome" ref="nome" v-model="rodadaDetalhes.nome" readonly hideDetails></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field label="Local" ref="local" v-model="rodadaDetalhes.local" readonly
                hideDetails></v-text-field>
            </v-col>
            <v-col sm="3" cols="6">
              <as-date-picker-menu label="Data Início" ref="data_inicio" v-model="rodadaDetalhes.data_inicio" readonly
                hideDetails></as-date-picker-menu>
            </v-col>
            <v-col sm="3" cols="6">
              <as-date-picker-menu label="Data Término" ref="data_fim" v-model="rodadaDetalhes.data_fim" readonly
                hideDetails></as-date-picker-menu>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col sm="3" cols="6">
              <as-date-picker-menu label="Data Veiculação" ref="data_veiculacao" readonly
                v-model="rodadaDetalhes.data_veiculacao" hideDetails></as-date-picker-menu>
            </v-col>
            <v-col sm="3" cols="6">
              <as-date-picker-menu label="Data Limite" ref="data_limite" readonly v-model="rodadaDetalhes.data_limite"
                hideDetails></as-date-picker-menu>
            </v-col>
            <v-col sm="3" cols="6">
              <v-text-field label="Estado" ref="estado" v-model="rodadaDetalhes.estado_nome" readonly
                hideDetails></v-text-field>
            </v-col>
            <v-col sm="3" cols="6">
              <v-text-field label="Cidade" ref="cidade" v-model="rodadaDetalhes.cidade_nome" readonly
                hideDetails></v-text-field>
            </v-col>
          </v-row>

          <v-row dense class="pt-4" v-if="
            rodadaDetalhes.logo ||
            rodadaDetalhes.banner ||
            rodadaDetalhes.planta
          ">
            <v-col sm="4" cols="12" v-if="rodadaDetalhes.banner">
              <v-card>
                <v-img :src="rodadaDetalhes.logo_nome" height="200px" v-if="rodadaDetalhes.logo"
                  @click="$refs.dialogoLogo.abrir()">
                  <v-card-title>Logo</v-card-title>
                </v-img>

                <v-card-subtitle class="pa-2">
                  <span class="grey--text" v-if="rodada.logo">Clique na imagem para ampliá-la</span>
                </v-card-subtitle>
              </v-card>
            </v-col>

            <as-dialogo ref="dialogoLogo" title="Logo" max-width="1200px">
              <v-img :src="rodadaDetalhes.logo_nome" height="600px" />
            </as-dialogo>

            <v-col sm="4" cols="12" v-if="rodadaDetalhes.banner">
              <v-card>
                <v-img :src="rodadaDetalhes.banner_nome" height="200px" v-if="rodadaDetalhes.banner"
                  @click="$refs.dialogoBanner.abrir()">
                  <v-card-title>Banner</v-card-title>
                </v-img>

                <v-card-subtitle class="pa-2">
                  <span class="grey--text" v-if="rodada.logo">Clique na imagem para ampliá-la</span>
                </v-card-subtitle>
              </v-card>
            </v-col>

            <as-dialogo ref="dialogoBanner" title="Banner" max-width="1200px">
              <v-img :src="rodadaDetalhes.banner_nome" height="600px" />
            </as-dialogo>

            <v-col sm="4" cols="12" v-if="rodadaDetalhes.planta">
              <v-card>
                <v-img :src="rodadaDetalhes.planta_nome" height="200px" v-if="rodadaDetalhes.planta"
                  @click="$refs.dialogoPlanta.abrir()">
                  <v-card-title>Planta</v-card-title>
                </v-img>

                <v-card-subtitle class="pa-2">
                  <span class="grey--text" v-if="rodada.logo">Clique na imagem para ampliá-la</span>
                </v-card-subtitle>
              </v-card>
            </v-col>

            <as-dialogo ref="dialogoPlanta" title="Planta" max-width="1200px">
              <v-img :src="rodadaDetalhes.planta_nome" height="600px" />
            </as-dialogo>
          </v-row>
        </v-form>
      </as-dialogo>

      <as-dialogo ref="dialogoIlhaImpressao" title="Ilha de Impressão" max-width="700px" hideCloseButton hideDivider>
        <v-label>Deseja usar a ilha de impressão do evento para imprimir seus pedidos
          e relatórios?</v-label>
        <div slot="botoes">
          <v-btn depressed class="mr-4" @click="usarIlhaImpressao(false)">Não</v-btn>
          <v-btn depressed color="primary" @click="usarIlhaImpressao(true)">Sim</v-btn>
        </div>
      </as-dialogo>
    </v-container>
  </div>
</template>

<script>
import Services from "../../services/services.js";
import ServiceRodadas from "../../services/rodadas.js";

export default {
  name: "Rodadas",
  data() {
    return {
      loading: false,
      exibirPesquisa: false,
      pesquisa: "",
      rodadas: [],
      headers: [],
      rodada: {},
      rodadaDetalhes: {},
      offLine: false,
      showOffline: undefined,
    };
  },
  mounted() {
    if (this.$auth.user.tipo == "administrador") {
      this.headers = [
        { text: "Nome", value: "nome", width: "40%" },
        { text: "Data Início", value: "data_inicio", width: "15%" },
        { text: "Data Término", value: "data_fim", width: "15%" },
        {
          text: "Local",
          value: "local",
          width: "25%",
          class: "hidden-xs-only",
        },
        {
          text: "Ativa",
          value: "ativa",
          sortable: false,
          width: "6%",
          align: "center",
        },
        {
          text: "",
          value: "opcoes",
          sortable: false,
          width: "5%",
          align: "end",
        },
      ];
    } else {
      this.headers = [
        { text: "Nome", value: "nome", width: "25%" },
        {
          text: "Administrador",
          value: "administrador_nome",
          width: "20%",
          class: "hidden-xs-only",
        },
        { text: "Data Início", value: "data_inicio", width: "12%" },
        { text: "Data Término", value: "data_fim", width: "12%" },
        {
          text: "Local",
          value: "local",
          width: "20%",
          class: "hidden-xs-only",
        },
        {
          text: "Ativa",
          value: "ativa",
          sortable: false,
          width: "6%",
          align: "center",
        },
        {
          text: "",
          value: "opcoes",
          sortable: false,
          width: "5%",
          align: "end",
        },
      ];
    }
    this.listar();

    this.rodada = { ...this.$store.state.rodada };
    if (!this.rodada.id) {
      this.deselecionaRodada();
    }
    document.addEventListener("keydown", this.setShowOffLineState);
    document.addEventListener("keyup", this.setShowOffLineState);
    // this.offLine = !!localStorage.getItem("offLine");
    this.offLine = true;
    this.showOffline = this.offLine;
  },
  unmounted() {
    document.removeEventListener("keydown", this.setShowOffLineState);
    document.removeEventListener("keyup", this.setShowOffLineState);
  },
  methods: {
    setShowOffLineState({ shiftKey }) {
      this.showOffline = shiftKey;
    },
    setOffLineState(value) {
      if (value) {
        localStorage.setItem("offLine", !!this.offLine);
      } else {
        localStorage.removeItem("offLine");
      }
    },
    podeEditar(dataFim) {
      return (
        new Date(
          dataFim.substring(0, 4) +
          "-" +
          dataFim.substring(5, 7) +
          "-" +
          dataFim.substring(8, 10)
        ) > new Date()
      );
    },
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    async listar() {
      this.loading = true;
      try {
        let result = await ServiceRodadas.index();
        this.rodadas = result.data.rodadas.sort((a, b) => a.data_inicio < b.data_inicio ? 1 : -1);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async abrirDialogoDetalhes(rodada) {
      this.rodadaDetalhes = rodada;
      this.$refs.dialogoDetalhes.abrir();
    },
    selecionarRodada(rodada) {
      if (this.rodada.id === (rodada && rodada.id)) {
        this.deselecionaRodada();
        localStorage.setItem("impressao_remota", false);
        this.$store.commit("setRodada", {});
      } else {
        localStorage.setItem("offLine", true);
        if (rodada.permitir_pedidos) {
          this.$refs.dialogoIlhaImpressao.abrir();
        }
        this.rodada = this.clone(rodada);
        this.$store.commit("setRodada", { ...rodada });
      }
    },
    deselecionaRodada() {
      this.rodada = {
        id: null,
        nome: "",
        data_inicio: "",
        data_fim: "",
        cidade_id: "",
        estado_id: "",
        administrador_id: "",
        data_veiculacao: "",
        estado_nome: "",
        cidade_nome: "",
      };
    },
    usarIlhaImpressao(value) {
      this.$refs.dialogoIlhaImpressao.fechar();
      localStorage.setItem("impressao_remota", value);
    },
  },
};
</script>

<style></style>
